import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import { Button } from '../styles';
import Portal from '../../../../Portal';
import Popup, { PopupTheme } from '../../../../Popup';
import { PopupBody } from '../styles';
import { ThemesState } from '../../../../../containers/Editor/reducer';
import { removeTheme } from '../../../../../containers/Editor/actions';

interface RemoveThemeProps {
	themeId: string;
	themes: ThemesState;
	dispatch: Dispatch<StoreState>;
	className?: string;
}

const RemoveTheme = ({ themeId, themes, className, dispatch }: RemoveThemeProps) => {
	const [isPopupDisplayed, setIsPopupDisplayed] = React.useState(false);

	const handleConfirm = () => {
		setIsPopupDisplayed(false);
		dispatch(removeTheme(themeId));
	};

	return (
		<>
			<Button
				disabled={Object.keys(themes).length === 1}
				onClick={() => setIsPopupDisplayed(true)}
			>
				<Translate value="messages.remove" />
			</Button>
			<Portal parentNode={document.body}>
				<Popup
					className={`prevent-drag ${className || ''}`}
					isDisplayed={isPopupDisplayed}
					label={I18n.t('messages.remove_theme')}
					theme={PopupTheme.DARK}
					onConfirm={handleConfirm}
					onCancel={() => setIsPopupDisplayed(false)}
				>
					<PopupBody>
						<Translate value="messages.remove_theme_question" />
					</PopupBody>
				</Popup>
			</Portal>
		</>
	);
};

export default RemoveTheme;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/RemoveTheme/index.tsx